import type React from 'react';
import { memo } from 'react';

import cn from 'classnames';

import { isEmptySessionNow } from '@shared/helpers';

import { EmptyStartTime } from '../empty-start-time';
import { SessionContent } from '../session-content';
import * as st from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	start: Date;
	end: Date;
}

export const EmptyDaySession: React.FC<Props> = memo(({ start, end, ...props }) => {
	const isNow = isEmptySessionNow({ start, end });

	return (
		<div className={cn(st.session, isNow && st.now)} {...props}>
			<EmptyStartTime start={start} end={end} />
			<SessionContent isNow={isNow} />
		</div>
	);
});
